/*
  PWR Blog page — client-side search over the currently-rendered article
  cards only (title + excerpt). Vanilla JS, no dependency. Filters only the
  articles on the current pagination page -- Shopify's own pagination is
  left intact rather than silently broken by this.
*/
(function () {
  var input = document.querySelector('[data-pwr-blog-search]');
  var clearBtn = document.querySelector('[data-pwr-blog-clear]');
  var allChip = document.querySelector('[data-pwr-blog-all]');
  var grid = document.querySelector('[data-pwr-blog-grid]');
  var emptyState = document.querySelector('[data-pwr-blog-empty]');

  if (!input || !grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-pwr-blog-card]'));
  var debounceId;

  function applyFilter(term) {
    var normalized = term.trim().toLowerCase();
    var visibleCount = 0;

    cards.forEach(function (card) {
      var listItem = card.closest('li');
      var title = (card.getAttribute('data-pwr-blog-title') || '').toLowerCase();
      var excerpt = (card.getAttribute('data-pwr-blog-excerpt') || '').toLowerCase();
      var matches = normalized === '' || title.indexOf(normalized) !== -1 || excerpt.indexOf(normalized) !== -1;

      if (listItem) {
        listItem.hidden = !matches;
      }
      if (matches) visibleCount += 1;
    });

    if (emptyState) {
      emptyState.hidden = visibleCount !== 0;
    }

    if (clearBtn) {
      clearBtn.hidden = normalized === '';
    }

    if (allChip) {
      allChip.classList.toggle('pwr-blog-chip--active', normalized === '');
    }
  }

  input.addEventListener('input', function () {
    var value = input.value;
    window.clearTimeout(debounceId);
    debounceId = window.setTimeout(function () {
      applyFilter(value);
    }, 150);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      applyFilter('');
    });
  }

  if (allChip) {
    allChip.addEventListener('click', function () {
      input.value = '';
      applyFilter('');
    });
  }
})();
